import React from "react";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { RadioButtonGroup, RadioOption } from "./RadioButtonGroup";
import "../../styles/imageStyles.css";

interface BooleanRadioGroupProps {
  value?: boolean;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
  size?: "small" | "middle" | "large";
  yesLabel?: string;
  noLabel?: string;
  title?: React.ReactNode;
  className?: string;
}

export const BooleanRadioGroup: React.FC<BooleanRadioGroupProps> = ({
  value,
  onChange,
  disabled = false,
  size,
  yesLabel = "Да",
  noLabel = "Нет",
  title,
  className,
}) => {
  const options: RadioOption[] = [
    {
      label: yesLabel,
      value: true,
      icon: <CheckOutlined className="icon-sm" />,
    },
    {
      label: noLabel,
      value: false,
      icon: <CloseOutlined className="icon-sm" />,
    },
  ];

  return (
    <RadioButtonGroup
      options={options}
      value={value}
      onChange={onChange}
      disabled={disabled}
      size={size}
      title={title}
      className={className}
    />
  );
};
